(function () {

	if (typeof window.awasi === 'undefined') {
		window.awasi = {};
	}

	let recaptchaBadgeTimer;

	/**
	 * Handle hover effect on footer links with custom colors.
	 *
	 * Set a custom CSS variable on the footer element when hovering over a link
	 * with custom background and foreground colors.
	 */
	window.awasi.handleFooterPropertyLinks = () => {
		const footerElement = document.querySelector('.site-footer');
		const footerLinks = document.querySelectorAll('.site-footer__destionations-link');

		if (footerElement && footerLinks.length > 0) {
			footerLinks.forEach(link => {
				const backgroundColor = link.getAttribute('data-main-color');
				const foregroundColor = link.getAttribute('data-foreground-color');

				if (backgroundColor && foregroundColor) {
					link.addEventListener('mouseenter', () => {
						footerElement.style.setProperty('--_footer-background-color', 'var(' + backgroundColor + ')');
						footerElement.style.setProperty('--_footer-foreground-color', 'var(' + foregroundColor + ')');
					});

					link.addEventListener('mouseleave', () => {
						footerElement.style.setProperty('--_footer-background-color', '');
						footerElement.style.setProperty('--_footer-foreground-color', '');
					});
				}
			});
		}
	}

	/**
	 * Toggles the aria-expanded attribute of the footer destinations toggle button
	 * to show/hide the destinations list.
	 */
	window.awasi.handleFooterPropertyButton = () => {
		const toggleButton = document.querySelector('.site-footer__destinations-toggle-button');
		const menuList = document.querySelector('.site-footer__destinations-list');

		if (toggleButton && menuList) {
			toggleButton.addEventListener('click', (event) => {
				event.preventDefault();
				const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
				toggleButton.setAttribute('aria-expanded', !isExpanded);
			});
		}
	}

	/**
	 * Toggles the is-scrolled class on the body element when the window's scrollY
	 * position exceeds 100px.
	 *
	 * @return {void}
	 */
	window.awasi.handleScroll = () => {
		const isScrolled = window.scrollY > 100;
		const hasDarkHeader = document.body.classList.contains('has-dark-header');

		document.body.classList.toggle('is-scrolled', isScrolled);
		document.body.classList.add('is-recaptcha-badge-visible');
		clearTimeout(recaptchaBadgeTimer);
		recaptchaBadgeTimer = setTimeout(() => {
			document.body.classList.remove('is-recaptcha-badge-visible');
		}, 1200);
		document.querySelector('.site-header__plan-trip-button').classList.toggle(
			'awa-button--clear',
			!isScrolled && !hasDarkHeader
		);
	}

	window.awasi.handleSkipLinkTarget = () => {
		const mainElement = document.querySelector('main');

		if (!mainElement) {
			return;
		}

		if (!mainElement.id) {
			mainElement.id = 'main';
		}

		if (!mainElement.hasAttribute('tabindex')) {
			mainElement.setAttribute('tabindex', '-1');
		}
	}

	window.awasi.handleHeaderMenu = () => {
		const menuToggleButton = document.querySelector('.site-header__menu-toggle');
		const headerNavigation = document.querySelector('.site-header__navigation');
		const headerElementsOutsideNavigation = document.querySelectorAll(
			'.site-header__inner a, .site-header__inner button, .site-header__inner input, .site-header__inner select, .site-header__inner textarea, .site-header__inner [tabindex]'
		);
		const setElementTabbable = (element, isTabbable) => {
			if (element === menuToggleButton) {
				return;
			}

			if (isTabbable) {
				if (element.hasAttribute('data-awasi-original-tabindex')) {
					const originalTabindex = element.getAttribute('data-awasi-original-tabindex');

					if (originalTabindex) {
						element.setAttribute('tabindex', originalTabindex);
					} else {
						element.removeAttribute('tabindex');
					}

					element.removeAttribute('data-awasi-original-tabindex');
				}

				return;
			}

			if (!element.hasAttribute('data-awasi-original-tabindex')) {
				element.setAttribute('data-awasi-original-tabindex', element.getAttribute('tabindex') || '');
			}

			element.setAttribute('tabindex', '-1');
		};
		const setHeaderElementsOutsideNavigationState = (isExpanded) => {
			headerElementsOutsideNavigation.forEach(element => {
				setElementTabbable(element, !isExpanded);
			});
		};
		const setHeaderNavigationState = (isExpanded) => {
			if (!headerNavigation) {
				return;
			}

			headerNavigation.toggleAttribute('inert', !isExpanded);
			headerNavigation.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
			setHeaderElementsOutsideNavigationState(isExpanded);
		};

		setHeaderNavigationState(false);

		if (menuToggleButton) {
			menuToggleButton.addEventListener('click', (event) => {
				event.preventDefault();
				const isExpanded = menuToggleButton.getAttribute('aria-expanded') === 'true';
				const isScrolled = document.body.classList.contains('is-scrolled');
				const hasDarkHeader = document.body.classList.contains('has-dark-header');
				const buttonText = menuToggleButton.querySelector('.site-header__menu-toggle-text');
				const closeText = menuToggleButton.getAttribute('data-close-text');
				const defaultText = menuToggleButton.getAttribute('data-default-text');
				const planTripButton = document.querySelector('.site-header__plan-trip-button');

				if (buttonText && closeText && defaultText) {
					buttonText.textContent = isExpanded ? defaultText : closeText;
				}

				menuToggleButton.setAttribute('aria-expanded', !isExpanded);
				document.body.classList.toggle('is-menu-opened', !isExpanded);
				setHeaderNavigationState(!isExpanded);
				menuToggleButton.focus();
				planTripButton.classList.toggle('awa-button--clear', isExpanded && planTripButton && !hasDarkHeader && !isScrolled);
			});
		}

		const headerNavigationContent = document.querySelector('.site-header__navigation-content');

		const headerMenuItemToggles = document.querySelectorAll('.site-header__main-menu-nav-toggle');

		headerMenuItemToggles.forEach(toggle => {
			toggle.addEventListener('click', (event) => {
				event.preventDefault();
				const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

				if (!isExpanded) {
					headerMenuItemToggles.forEach(otherToggle => {
						if (otherToggle !== toggle) {
							otherToggle.setAttribute('aria-expanded', false);
							otherToggle.closest('.site-header__main-menu-nav-item').classList.remove('is-opened');
							otherToggle.nextElementSibling.classList.add('is-hidden');
						}
					});
				}

				toggle.setAttribute('aria-expanded', !isExpanded);
				toggle.nextElementSibling.classList.toggle('is-hidden', isExpanded);
				toggle.closest('.site-header__main-menu-nav-item').classList.toggle('is-opened');

			});
		});

		const headerResortMenuToggle = document.querySelector('.is-resort-menu .site-header__main-menu-nav-toggle');
		if (headerResortMenuToggle) {
			headerResortMenuToggle.addEventListener('click', (event) => {
				event.preventDefault();

				if (headerNavigationContent) {
					headerNavigationContent.classList.toggle('is-resort-menu-opened');
				}
			});
		}

		const mainMenu = document.querySelector('.site-header__main-menu-nav-list--level-0');

		if (mainMenu) {
			const defaultImageUrl = mainMenu.getAttribute('data-image-url');
			const navigationImageDiv = document.querySelector('.site-header__navigation-image-list');

			if (navigationImageDiv && defaultImageUrl) {
				const width = parseInt(mainMenu.getAttribute('data-image-width'), 10);
				const height = parseInt(mainMenu.getAttribute('data-image-height'), 10);
				const sizeAttrs = (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) ? ' width="' + width + '" height="' + height + '"' : '';

				navigationImageDiv.innerHTML = '<img src="' + defaultImageUrl + '" alt="Default menu image"' + sizeAttrs + ' class="site-header__navigation-image is-visible" data-id="main-image" />';
			}
		}

		const mainOptions = document.querySelectorAll('.site-header__main-menu-nav-item--level-0, .site-header__main-menu-nav-item--level-2');

		mainOptions.forEach(option => {
			const imageUrl = option.getAttribute('data-image-url');
			const imageId = option.getAttribute('data-image-id');
			
			const altText = ((option.getAttribute('data-image-alt') || '').trim() || (option.querySelector('a')?.textContent || option.textContent || '')).replace(/\s+/g, ' ').trim();
			const width = parseInt(option.getAttribute('data-image-width'), 10);
			const height = parseInt(option.getAttribute('data-image-height'), 10);
			const sizeAttrs = (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) ? ' width="' + width + '" height="' + height + '"' : '';
			
			const navigationImageDiv = document.querySelector('.site-header__navigation-image-list');

			if (navigationImageDiv && imageUrl && imageId) {
				navigationImageDiv.innerHTML += '<img src="' + imageUrl + '" alt="' + altText.replace(/"/g, '&quot;') + '"' + sizeAttrs + ' class="site-header__navigation-image" data-image-id="' + imageId + '" />';
			}

			option.addEventListener('mouseenter', () => {
				if (navigationImageDiv && imageUrl && imageId) {
					const images = navigationImageDiv.querySelectorAll('.site-header__navigation-image:not([data-id="main-image"])');

					images.forEach(img => {
						if (img.getAttribute('data-image-id') === imageId) {
							img.classList.add('is-visible');
						} else {
							img.classList.remove('is-visible');
						}
					});
				}
			});

			option.addEventListener('mouseleave', () => {
				if (navigationImageDiv) {
					const images = navigationImageDiv.querySelectorAll('.site-header__navigation-image:not([data-id="main-image"])');
					images.forEach(img => {
						img.classList.remove('is-visible');
					});
				}
			});
		});

		const resortLinks = document.querySelectorAll('.site-header__main-menu-nav-link--level-2');

		resortLinks.forEach(link => {
			link.addEventListener('mouseenter', () => {
				const foregroundColor = link.getAttribute('data-foreground-color');
				const backgroundColor = link.getAttribute('data-background-color');
				const contentClass = link.getAttribute('data-class');
				const siteHeader = document.querySelector('.site-header');
				const planTripButton = document.querySelector('.site-header__plan-trip-button');

				if (planTripButton) {
					planTripButton.classList.add('awa-button--opposite');
				}

				if (foregroundColor && backgroundColor && headerNavigationContent) {
					headerNavigationContent.style.setProperty('--_navigation-fg-color', 'var(' + foregroundColor + ')');
					headerNavigationContent.style.setProperty('--_navigation-bg-color', 'var(' + backgroundColor + ')');
				}

				if (contentClass && siteHeader) {
					siteHeader.classList.add(contentClass);
					siteHeader.classList.add('is-resort-menu-opened');
				}

			});

			link.addEventListener('mouseleave', () => {
				const contentClass = link.getAttribute('data-class');
				const siteHeader = document.querySelector('.site-header');
				const planTripButton = document.querySelector('.site-header__plan-trip-button');

				if (planTripButton) {
					planTripButton.classList.remove('awa-button--opposite');
				}

				if (headerNavigationContent) {
					headerNavigationContent.style.setProperty('--_navigation-fg-color', '');
					headerNavigationContent.style.setProperty('--_navigation-bg-color', '');
				}

				if (siteHeader && contentClass) {
					siteHeader.classList.remove(contentClass);
					siteHeader.classList.remove('is-resort-menu-opened');
				}

			});
		});

		const languageSwitchers = document.querySelectorAll('.language-switcher__current');
		const languageSwitcherLists = document.querySelectorAll('.language-switcher__list');
		const setLanguageSwitcherState = (isExpanded) => {
			languageSwitcherLists.forEach(list => {
				list.toggleAttribute('inert', !isExpanded);
				list.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
			});
		};

		setLanguageSwitcherState(false);

		languageSwitchers.forEach(languageSwitcher => {
			languageSwitcher.addEventListener('click', (event) => {
				event.preventDefault();
				document.body.classList.toggle('is-language-switcher-opened');
				setLanguageSwitcherState(document.body.classList.contains('is-language-switcher-opened'));
			});
		});

		// Handle GTranslate language links.
		// Sub-directory mode (pro): base.js sets real hrefs, let the browser navigate.
		// Cookie mode (free): set googtrans cookie and reload.
		const languageLinks = document.querySelectorAll('.language-switcher a.nturl');
		languageLinks.forEach(link => {
			link.addEventListener('click', (event) => {
				document.body.classList.remove('is-language-switcher-opened');
				setLanguageSwitcherState(false);

				const href = link.getAttribute('href');
				if (href && href !== '#') {
					// Sub-directory mode: navigate to the URL set by base.js.
					return;
				}

				// Cookie mode fallback.
				event.preventDefault();
				const langCode = link.getAttribute('data-gt-lang');
				if (langCode) {
					const defaultLang = document.documentElement.lang || 'en';
					document.cookie = 'googtrans=/' + defaultLang + '/' + langCode + '; path=/';
					document.cookie = 'googtrans=/' + defaultLang + '/' + langCode + '; path=/; domain=' + window.location.hostname;
					window.location.reload();
				}
			});
		});

		// if press ESC key close all menus
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				if (document.body.classList.contains('is-menu-opened')) {
					menuToggleButton.click();
				}
				document.body.classList.remove('is-language-switcher-opened');
				setLanguageSwitcherState(false);
			}
		});
	}

	window.awasi.handleButtons = () => {
		document.querySelectorAll('.awa-button').forEach(button => {
			const backgroundImage = button.querySelector('.awa-button__button-background');
			if (!backgroundImage) {
				const buttonText = button.textContent;
				button.textContent = '';
				const textSpan = document.createElement('span');
				textSpan.classList.add('awa-button__button-text');
				textSpan.textContent = buttonText;
				button.appendChild(textSpan);

				const emptyButtonImage = document.createElement('span');
				emptyButtonImage.classList.add('awa-button__button-background');
				emptyButtonImage.classList.add('awa-button__button-background--default');
				button.prepend(emptyButtonImage);
				const fullButtonImage = document.createElement('span');
				fullButtonImage.classList.add('awa-button__button-background');
				fullButtonImage.classList.add('awa-button__button-background--hover');
				button.prepend(fullButtonImage);
			}
		});
	}

	window.awasi.showVideoModal = (video_url) => {
		const videoModal = document.querySelector('.video-modal');
		const videoPlayer = videoModal.querySelector('.video-modal__player');
		const closeButton = videoModal.querySelector('.video-modal__close-button');

		if (videoModal && videoPlayer && closeButton) {
			videoPlayer.src = video_url;
			videoPlayer.load();
			videoPlayer.play();

			document.body.classList.add('show-video-modal');

			closeButton.addEventListener('click', (event) => {
				event.preventDefault();
				videoPlayer.pause();
				videoPlayer.src = '';
				document.body.classList.remove('show-video-modal');
			});

		}
	}

	window.awasi.openBookingWidget = () => {
		if (typeof window.bookNow === 'function') {
			try {
				window.bookNow();
			} catch (error) {
				console.error('Error opening Selfbook widget:', error);
			}
		} else {
			console.error('Selfbook widget not loaded (window.bookNow is not available)');
		}
	}

	window.awasi.handleBookingLinks = () => {
		const bookingSelectors = [
			'a[href*="##booknow##"]',
			'.site-header__plan-trip-button'
		];

		document.querySelectorAll(bookingSelectors.join(', ')).forEach(element => {
			element.addEventListener('click', (event) => {
				event.preventDefault();
				window.awasi.openBookingWidget();
			});
		});
	}

	document.addEventListener("DOMContentLoaded", () => {
		window.awasi.handleSkipLinkTarget();
		window.awasi.handleFooterPropertyLinks();
		window.awasi.handleFooterPropertyButton();
		window.awasi.handleHeaderMenu();
		window.awasi.handleButtons();
		window.awasi.handleBookingLinks();
	});

	window.addEventListener('scroll', () => {
		window.awasi.handleScroll();
	});
})();
